/* eslint-env jest */
import { cartHasItems } from './cartHasItems';

// #5192: an empty cart must not offer "Continue to Payment".
describe('cartHasItems', () => {
  it('is false with no customer, no cart, or no packages', () => {
    expect(cartHasItems(null)).toBe(false);
    expect(cartHasItems({})).toBe(false);
    expect(cartHasItems({ cart: {} })).toBe(false);
    expect(cartHasItems({ cart: { orderPackages: [] } })).toBe(false);
  });

  it('is true when the cart has a package', () => {
    expect(cartHasItems({ cart: { orderPackages: [{ id: 1 }] } })).toBe(true);
  });

  it('prefers the priority cart, like the rest of the page', () => {
    expect(cartHasItems({ priorityCart: { orderPackages: [{ id: 1 }] }, cart: { orderPackages: [] } })).toBe(true);
    expect(cartHasItems({ priorityCart: { orderPackages: [] }, cart: { orderPackages: [{ id: 1 }] } })).toBe(false);
  });
});
